import styled from 'styled-components';
import tw, { classnames, backgroundColor, textColor, display, alignItems, space, borderRadius, padding, transitionProperty, fontSize } from 'tailwindcss-classnames';

export const OptionsItem = styled.div.attrs({
    className: classnames(backgroundColor('bg-gpas-700'), display('flex'), alignItems('items-center'), space('space-x-1'), borderRadius('rounded-sm'), padding('py-1', 'px-2'), transitionProperty('transition-transform'))
})``;

export const OptionTitleSpan = styled.span.attrs({
    className: classnames(textColor('text-gpas-700'), display('block'), fontSize('text-sm'))
})`
    line-height: 0.5rem;
    font-weight: 200;
`;
